import { NavLink, Outlet } from 'react-router-dom';
import { AlertTriangle, Cpu, List, Package, ScanSearch } from 'lucide-react';

/**
 * La sección Dispositivos: una cabecera y pestañas con su propia ruta cada
 * una, como Aperturas. La ficha de un dispositivo
 * vive fuera del layout, como la de un empleado: en el móvil, cabecera más
 * pestañas más las de la ficha se comen media pantalla.
 */
const TABS = [
  { to: '/dispositivos', label: 'Inventario', icon: List, end: true },
  { to: '/dispositivos/stock', label: 'Stock', icon: Package, end: false },
  { to: '/dispositivos/incidencias', label: 'Incidencias', icon: AlertTriangle, end: false },
  { to: '/dispositivos/auditoria', label: 'Auditoría', icon: ScanSearch, end: false },
];

export default function DispositivosLayout() {
  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <div className="flex items-center gap-3">
        <div className="bg-sereno-dark p-2.5 rounded-xl text-white"><Cpu size={22} /></div>
        <div>
          <h1 className="text-2xl font-bold text-sereno-dark">Dispositivos</h1>
          <p className="text-slate-500 text-sm mt-0.5">
            Smartlocks, openers, bridges, keypads, bots, hubs y demás: qué hay, dónde está y qué le ha pasado.
          </p>
        </div>
      </div>

      <div className="border-b border-slate-200 dark:border-white/10">
        <nav className="flex gap-1 -mb-px overflow-x-auto">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-4 py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors ${
                  isActive
                    ? 'border-sereno-dark text-sereno-dark font-medium dark:border-white dark:text-white'
                    : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                }`
              }
            >
              <Icon size={15} />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
